export function BestPropFirmsHero() {
    return (
      <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 overflow-hidden py-16 md:py-24 text-yellow-100 border-b border-yellow-700">
        <div className="absolute inset-0 opacity-10">
          <video
            autoPlay
            muted
            loop
            playsInline
            className="absolute inset-0 w-full h-full object-cover"
          >
            <source src="/assets/hero-bg.mp4" type="video/mp4" />
          </video>
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/50 to-black/80" />
        </div>
  
        <div className="relative z-10 container mx-auto px-4 text-center max-w-3xl">
          <h1 className="text-4xl md:text-5xl font-bold text-yellow-400 mb-4">
            Best Prop Trading Firms 2025
          </h1>
          <p className="text-yellow-300 text-lg mb-8">
            Compare top prop firms and save big on your next challenge with exclusive promo codes verified by PropViper.
          </p>
  
          <div className="flex justify-center flex-wrap gap-4 text-yellow-400 text-sm font-semibold mb-10">
            <span className="bg-white/10 backdrop-blur px-4 py-2 rounded-full">Max Funding Up to $1M</span>
            <span className="bg-white/10 backdrop-blur px-4 py-2 rounded-full">Profit Split Up to 90%</span>
            <span className="bg-white/10 backdrop-blur px-4 py-2 rounded-full">Verified Promo Codes</span>
          </div>
  
          <a
            href="#firms"
            className="inline-flex items-center justify-center bg-yellow-400 text-black px-6 py-3 rounded-full font-semibold shadow-lg hover:bg-yellow-300 transition"
          >
            View Top Prop Firms
          </a>
        </div>
      </section>
    );
  }
  
  export default BestPropFirmsHero;
  